import { doc, collection, getDocs, getDoc, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";

export class ReservationSettingsController {
  static TABLE_NAME = TableName.RESERVATIONSETTINGS;

  static getViaId = ({ id, resolve, reject }) => {
    let errorMessage =
      "Unable to get the selected reservation setting details.\nPlease contact administrator for assistance.";
    getDoc(doc(db, this.TABLE_NAME, id))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static getAllViaCollaborationId = ({ collaborationId, resolve, reject }) => {
    const q = query(
      collection(db, this.TABLE_NAME),
      where("collaborationId", "==", collaborationId)
    );
    let errorMessage =
      "Unable to get all the reservation settings.\nPlease contact administrator for assistance.";
    getDocs(q)
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
